import { noValidation } from '@post-office/placement-common-v2';
import { PlacementFrontend } from '../index';
import Link from '@atlaskit/link';
import Story16Icon from '@atlaskit/icon-object/glyph/story/16';
import { Inline, Stack } from '@atlaskit/primitives';

export type MessageTemplateContext = {
	message?: string;
	link?: {
		href: string;
		text: string;
	};
};

export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageTemplateContext>(),
		Component: ({ message, link }: MessageTemplateContext) => (
			<Inline alignBlock="center" space="space.200">
				<Story16Icon label="" />
				<Stack>
					<span>{message}</span>

					{link && (
						<Link href={link.href} target="blank">
							{link.text}
						</Link>
					)}
				</Stack>
			</Inline>
		),
	},
});
